<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.posbranchmanagement') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-else>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>{{ $t('message.posbranchname') }} *</label>
                    <input
                      v-model="$v.form.name.$model"
                      :class="['form-control', { 'is-invalid': $v.form.name.$error }]"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-6">
                    <label>
                      {{ $t('message.posbranchnameshort') }} *
                      <vs-tooltip
                        :text="$t('message.runningcodenumber')"
                        position="top"
                        style="float: right;margin-left: 5px;">
                        <i class="fas fa-info-circle"/>
                      </vs-tooltip>
                    </label>
                    <input
                      v-model="$v.form.nameShort.$model"
                      :placeholder="$t('placeholder.maximumlength6char')"
                      :maxlength="6"
                      :class="['form-control text-uppercase', { 'is-invalid': $v.form.nameShort.$error }]"
                    >
                  </div>
                  <div
                    v-if="nameShortUppercase"
                    class="col-6 pl-0">
                    <label>{{ $t('message.preview') }}</label>
                    <div class="preview-short-name">
                      <span
                        v-html="$t('message.previewpscode', {
                          name: nameShortUppercase,
                          code: `${moment().format('YYYY/MM/DD')}/01`,
                        })"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.location')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>{{ $t('message.address') }}</label>
                    <b-form-textarea
                      v-model="form.address"
                      style="min-height: 70px;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.config')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col-md-6">
                    <label>
                      {{ $t('message.posbranchcountingstrock') }}
                      <vs-tooltip
                        :text="$t('message.cutstockfromselectedwarehouse')"
                        position="top"
                        style="float: right;margin-left: 5px;">
                        <i class="fas fa-info-circle"/>
                      </vs-tooltip>
                    </label>
                    <select
                      v-model="form.whId"
                      class="form-control custom-select"
                    >
                      <option :value="null">
                        {{ $t('placeholder.select') }}
                      </option>
                      <option
                        v-for="(item, index) in form.whItems"
                        :key="index"
                        :index="index"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignproducts')"/>
            <BaseNotFoundData
              v-if="!products.length"
              :title="$t('apps.pos.message.notfoundproduct')"
              :detail="$t('apps.pos.message.createproduct')"
            />
            <base-assign-items
              v-else
              v-model="form.assignProductIds"
              :items="form.assignProductItems"
            />
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.favoriteproducts')"/>
            <base-assign-items
              v-model="form.favoriteProductIds"
              :items="form.favoriteProductItems"
            />
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!isSubmitted"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="onCancel">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="onSave">{{ $t('button.save') }}</button>
          </div>
          <div
            v-else
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseModalOverLimit
      :id="modalOverLimitId"
      :headerText="$t('overlimit.branch.header')"
      :bodyTextUnitPrice="$t('overlimit.branch.body.unitprice', { number: getCurrencyWithNumber(numberel(pricing.branch, '0,0')) })"
      :bodyTextPerMonth="$t('overlimit.branch.body.permonth')"
    />

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import _ from 'lodash'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,
      isSubmitted: false,
      form: {
        name: null,
        nameShort: null,
        address: null,
        whId: null,
        whItems: [],
        assignProductIds: [],
        assignProductItems: [],
        favoriteProductIds: [],
        favoriteProductItems: [],
      },
      formOriginal: null,
      modalOverLimitId: 'modalOverLimitId',
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      nameShort: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      warehouses: 'getWarehouses',
    }),
    nameShortUppercase () {
      return this.form.nameShort
        ? this.form.nameShort.trim().toUpperCase()
        : null
    },
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 1,
    })
  },
  async mounted () {
    await this.fetchData()
    this.formOriginal = _.cloneDeep(this.form)
    const isAvailableToCreate = this.$store.state.shop.availableToCreate.branch
    if (!isAvailableToCreate) {
      $(`#${this.modalOverLimitId}`).modal('show')
    }
  },
  destroyed () {
    this.leavePage(this.$Progress)
  },
  methods: {
    ...mapActions([
      'getShopUseLimit',
      'getShopAvailableToCreate',
    ]),
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    async fetchData () {
      this.ready = false
      await Promise.all([
        this.getProducts(),
        this.getWarehouses(),
        this.getShopUseLimit(),
        this.getShopAvailableToCreate({ type: 'branch' }),
        this.getPricing(),
      ])
      this.ready = true
      this.showFinish(this.$Progress)
    },
    async getProducts () {
      this.form.assignProductItems = []
      this.form.favoriteProductItems = []
      await this.$store.dispatch('getProducts')
      for (const product of this.products) {
        const item = {
          text: product.product_name,
          value: product.product_id,
        }
        this.form.assignProductItems.push(item)
        this.form.favoriteProductItems.push(item)
      }
    },
    async getWarehouses () {
      this.form.whItems = []
      await this.$store.dispatch('getWarehouses')
      for (const warehouse of this.warehouses) {
        const item = {
          text: warehouse.warehouse_name,
          value: warehouse.warehouse_id,
        }
        this.form.whItems.push(item)
      }
    },
    onCancel () {
      this.ready = false
      this.form = _.cloneDeep(this.formOriginal)
      setTimeout(() => this.ready = true, 1000)
    },
    async onSave () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return this.scrollToTop(600)
      }
      this.isSubmitted = true
      const response = await this.$store.dispatch('insertPosBranch', {
        'name': this.form.name,
        'name_short': this.form.nameShort.toUpperCase().trim(),
        'address': this.form.address,
        'wh_id': this.form.whId,
      })
      if (response.success) {
        await Promise.all([
          this.$store.dispatch('updatePosBranchAssignProductIds', {
            id: response.data._id,
            params: {
              'product_ids': this.form.assignProductIds,
            },
          }),
          this.$store.dispatch('updatePosBranchFavoriteProductIds', {
            id: response.data._id,
            params: {
              'product_ids': this.form.favoriteProductIds,
            },
          }),
        ])
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'PosBranchAll',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.preview-short-name {
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;
  border: solid 1px #ced4da;
  border-radius: 4px;
  color: #495057;
  background: #e9ecef;
  padding: .375rem .75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/branch/New.vue